import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import { FormControl, FormGroup, Row, Col, Button, Modal} from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import 'src/css/LoginForm.css'
import 'src/i18n';
import { withTranslation, Trans } from 'react-i18next';

class SignUpForm extends Component {
  
  constructor() {
    super();
    this.state = {
      showModal: false,
      errorMessage: ''
    }
    // 画面最上部まで移動
    window.scrollTo(0,0);
    this.onClick = this.onClick.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
  }

  handleModal(){
    window.location.href = '/verification'
  }

  handleHideModal() {
  this.setState(
      {
        isNotSame: false,
        showModal: false,
        isNotOK: true
      }
    );
  }

  handleShowModal() {
    this.setState({showModal: true });
  }

  onClick() {
      // リセット
    this.setState({
      isNotSame: false,
      isNotOK: true
    })
    if (this.inputId.value === '' || this.inputMailAddress1.value === '' || 
    this.inputMailAddress2.value === '' || this.inputPassword1.value === '' || 
    this.inputPassword2.value === ''){
      this.setState({
          isNotSame: true,
          errorMessage: <Trans i18nKey="Message.PleaseCompleteAllForms">Please complete all forms.</Trans>
        })
        this.inputPassword1.value = ''
        this.inputPassword2.value = ''
        return;
    }

    let email1 = this.inputMailAddress1.value;
    let email2 = this.inputMailAddress2.value;
    let pass1 = this.inputPassword1.value;
    let pass2 = this.inputPassword2.value;

    // パスワードとメールアドレスの再入力値が同じ値か
    if (pass1 !== pass2 || email1 !== email2) {
        this.setState({
            isNotSame: true,
            isNotOK: true,
            errorMessage: <Trans i18nKey="Message.EmailOrPasswordsDoNotMatch">Email or Passwords do not match.</Trans>
        })
        // パスワード欄はリセット
        this.inputPassword1.value = ''
        this.inputPassword2.value = ''
        return;
    }

    this.setState({
      isNotSame: false,
      isNotOK: false
    });
    this.props.signUp(this.inputId.value, email1, pass1);

  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
          {(() => {
              return (
                <Row>
                  {
                    this.props.isSignUpFailed && !this.state.isNotSame?
                    <Col xsOffset={1} xs={10}>
                        <p>
                          <Trans i18nKey="Message.SignUpFailed">
                            Sign up failed with errors below.<br/>
                            1. The same VIN No. has already been registered.<br/>
                            2. The VIN No. isn't registered with the insurance company.<br/>
                            3. Incorrect email address format.<br/>
                            4. Incorrect password format.<br/>
                            Please check your input again.
                          </Trans>
                        </p>
                    </Col> :
                    <Col xsOffset={1} xs={10}>
                        <p>{this.state.errorMessage}</p>
                    </Col>
                  }
                </Row>
              );
          })()}
      </div>
  );


    const ConfirmButton = () => (
      <button type="submit" id="circleButton" disabled={this.props.signUpLoading} onClick={this.onClick}>
        {
          this.props.signUpLoading ? <FontAwesomeIcon size='1x' icon={faSpinner} spin /> : <Trans i18nKey="SignUp.SignUp">Sign Up</Trans>
        }
      </button>
    );

    const BackButton = () => (
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Link to="/login"> 
            <Button bsStyle="link" className="backButton">&lt;&lt; <Trans i18nKey="SignUp.Back">Back to login page</Trans></Button>
          </Link>
        </Col>
      </Row>
    );

    return (
      <div>
        {(this.state.isNotSame || (this.props.isSignUpFailed && !this.state.isNotOK)) &&(
          <Modal show={true} onHide={this.handleHideModal} dialogClassName="check-modal">
            <Modal.Body>
              <Error />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleHideModal}>OK</Button>
            </Modal.Footer>
          </Modal>
        )}
        {this.props.signUpSucceed && (
          <Modal show={true} onHide={this.handleHideModal} dialogClassName="check-modal">
            <Modal.Body>
              <Trans i18nKey="Message.UserRegistrationCompleted">
                User registration completed!<br/>
                Please check your email and register verification code in next page!
              </Trans>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleModal}>OK</Button>
            </Modal.Footer>
          </Modal>
        )}
        <BackButton />
        {/* ユーザ名入力フォーム */}
        <FormGroup controlId="formHorizontalId" >
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.ID">VIN No.</Trans></p>
              <p className="formTextDescription"><Trans i18nKey="SignUp.IdDescription">*refer to My Toyota menu -&gt; Vehicle Info</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputId = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* メールアドレス入力フォーム */}
        <FormGroup controlId="formHorizontalEmail1">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="SignUp.Email">Email</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputMailAddress1 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* メールアドレス確認用入力フォーム */}
        <FormGroup controlId="formHorizontalEmail2">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="SignUp.EmailConfirm">Email(Re-enter for confirmation)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputMailAddress2 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* パスワード入力フォーム */}
        <FormGroup controlId="formHorizontalPassword1">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.Password">Password</Trans></p>
              <p className="formTextDescription"><Trans i18nKey="SignUp.PasswordDescription">(Requirements - Minimum length 8)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword1 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* パスワード再入力フォーム */}
        <FormGroup controlId="formHorizontalPassword2">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="SignUp.PasswordConfirm">Password(Re-enter for confirmation)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword2 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* サインアップボタン */}
        <FormGroup>
          <Row id="button-forms">
            <ConfirmButton />
            <div className="explanation">
              <Trans i18nKey="SignUp.VerificationDescription">
                If you have already received a verification code on email,<br/>
                please click the button below to verify.
              </Trans>
            </div>
            <Link to="/verification" xs={12}>
              <Button id="move-button">
                <Trans i18nKey="SignUp.Verification">
                  Account Verification
                </Trans>
              </Button>
            </Link>
            <Col className="HeartLogo" md={4} sm={4} xs={10} mdOffset={4} smOffset={4} xsOffset={1}></Col>
          </Row>
        </FormGroup>
        <div className='mini-div' />
      </div>
    );
  }
}

export default withTranslation()(withRouter(SignUpForm));



// WEBPACK FOOTER //
// ./src/component/SignUp/SignUpForm.js